import React, { type ReactNode } from "react";
import { Error } from "components/chrome/main_view/info_messages";
import Loader from "components/shared/loader";
import { useUser } from "users/hooks/useUser";

export interface AuthenticationProps {
  children?: ReactNode;
}

export const Authentication = ({ children }: AuthenticationProps) => {
  const { data: user, error } = useUser();
  if (error) {
    return (
      <Error title="Please Try Again">
        There was an error processing your request. Please reload the page and
        try again.
      </Error>
    );
  }
  if (!user) {
    return <Loader />;
  }
  return <>{children}</>;
};
